// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gWMZ","field":"styles_field__3s7a1","fieldCol":"styles_fieldCol__FI6YH","diffCol":"styles_diffCol__T21V8","diff":"styles_diff__WCXOR"};